import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-osw-files',
  templateUrl: './osw-files.component.html',
  styleUrls: ['./osw-files.component.scss']
})
export class OswFilesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
